<template>
  <div>
    <div v-if="loginUserError">
      <global-header is-login></global-header>

      <div class="wrapper">
        <div class="container">
          <div class="row">
            <div class="col-lg-5 img_login">
              <img
                src="../assets/img/index/ttl_nd_cs.png"
                alt=""
                class="img-fluid"
              />
            </div>
            <div class="col-lg-7 form_login">
              <form v-if="!isMaintenance" ref="loginForm">
                <p>取引先様はこちらからログインしてください</p>

                <div class="row">
                  <div class="col-md-8">
                    <label-input
                      name="email"
                      v-model="user_id"
                      label="ID"
                    ></label-input>
                    <label-input
                      type="password"
                      name="password"
                      v-model="password"
                      label="PASS"
                    ></label-input>
                  </div>
                  <div class="col-md-4">
                    <input
                      type="submit"
                      value="LOGIN"
                      class="btn_login"
                      @click.prevent="loginHandler"
                      :disabled="isProcessing"
                    />
                  </div>
                </div>

                <div class="alert alert-danger mt-4" v-if="login_message">
                  {{ login_message }}
                </div>

                <div class="forget">
                  <a
                    href="#"
                    @click="openForgetModalHandler"
                    v-bs-modal="'forget'"
                    >ログインパスワードを忘れた方</a
                  >
                </div>
              </form>
              <div class="alert alert-danger" v-else>
                ただいまメンテナンス中です<br />
                しばらくお待ちください
              </div>
            </div>
          </div>
          <!-- モーダル部分始まり -->
          <bs-modal id="forget" show-header dialog-centered>
            <template slot="modal-title">
              <h5 class="modal-title" id="exampleModalLabel">
                仮パスワードの発行
              </h5>
            </template>

            <p>
              入力されたユーザＩＤに登録されている<br />メールアドレス宛に仮パスワードを送信します。
            </p>

            <div class="form_login">
              <label-input
                v-model="reset_user_id"
                label="ユーザID(メールアドレス)"
              ></label-input>

              <div
                :class="`alert alert-${reset_message_status} mb-4`"
                v-if="reset_message_body"
              >
                {{ reset_message_body }}
              </div>

              <div class="text-center">
                <button
                  type="button"
                  class="btn btn-lg btn-primary"
                  @click="resetPasswordHandler"
                  :disabled="finishedReset"
                >
                  仮パスワードを送信
                </button>
              </div>
            </div>
          </bs-modal>
          <!-- モーダル部分終わり -->

          <new-password-modal
            :user-id="user_id"
            is-before-login
            @changed="loginAfterChangePasswordHandler"
          ></new-password-modal>

          <div class="row txt_login">
            <div class="col-md-10 a_mail">
              <p>
                ND-netとは、日東電工ベースマテリアルが提供するインターネットからダイレクトに発注していただけるサービスです。
                ご発注に止まらず納期や運送便の確認、納品書のダウンロード等、リアルタイムに物流情報をご参照、ご利用いただくことが可能になります。
                また、見積依頼、サンプル依頼、環境書類のご依頼や各種資料のダウンロード等も可能となっております。
                ご利用対象は当社のお得意様に、限定させて頂いております。
                ご加入お申し込みをいただいたのち、IDとパスワードを発行させていただき、ご利用可能となります。
                ND-netをご利用をご希望されるお得意先様で弊社と新規にお取引をご希望のお客様は、まずは
                <a :href="inquiry_url" target="_blank">
                  メール
                </a>
                またはお電話にてお問い合わせください。弊社担当者より、折り返しご連絡させていただきます。
                既に弊社とお取引がございますお得意先様で、ND-netのご利用をご希望されるお客様は
                <a href="https://www.nittobase.com/ndnet/" target="_blank">
                  こちらから
                </a>
                お申し込みください。
              </p>
            </div>
            <div class="col-md-2">
              <img
                src="../assets/img/index/illust01.png"
                alt=""
                class="img-fluid"
              />
            </div>
          </div>
          <div class="row bnr_login">
            <ul>
              <li class="btn_new"><p>新たにご利用を希望されるお客様</p><a href="https://www.nittobase.com/ndnet/" target="_blank"><i aria-hidden="true" class="fa fa-caret-right"></i>新規ご加入のお申込み</a></li>
              <li class="btn_invoice"><p>既にご加入済みのお客様</p><a href="https://www.nittobase.com/ndnet/denshika" target="_blank"><i aria-hidden="true" class="fa fa-caret-right"></i>納品書・請求書の電子化のお申込み</a></li>
            </ul>
            <p>ND-netのご加入状況がご不明の場合は、お手数ではございますが弊社までお問い合わせください</p>
          </div>
        </div>
      </div>

      <global-footer></global-footer>
      <bs-modal-backdrop></bs-modal-backdrop>
    </div>

    <error-page v-else></error-page>
  </div>
</template>

<script>
import { store as loginUser } from "../store/LoginUser";
import NewPasswordModal from "../components/Modal/NewPassword";

export default {
  components: {
    NewPasswordModal
  },

  data() {
    return {
      user_id: "",
      password: "",
      login_message: "",
      reset_user_id: "",
      reset_message_status: "",
      reset_message_body: "",
      inquiry_url: "",

      finishedReset: false,
      isMaintenance: false,
      isProcessing: false
    };
  },

  computed: {
    loginUserError() {
      return loginUser.noError;
    }
  },

  created() {
    this.getInitDataHandler();
  },

  methods: {
    /**
     * Get initial data from ASTERIA
     */
    async getInitDataHandler() {
      const response = await this.postAsteria("Login", "getInitData", {
        user_id: this.user_id,
        password: this.password
      });

      if (response.responseData.return != "0") {
        this.isMaintenance = true;
        return;
      }

      this.inquiry_url = response.responseData.inquiry_url;
    },
    async loginHandler() {
      this.login_message = "";
      this.isProcessing = true;

      const response = await this.postAsteria("Login", "login", {
        user_id: this.user_id,
        password: this.password,
        login_url_di: "1"
      });

      switch (response.responseData.return) {
        // ログイン成功
        // Login succeed
        case 0:
          if (window.external && "AutoCompleteSaveForm" in window.external) {
            window.external.AutoCompleteSaveForm(this.$refs.loginForm);
          }

          this.submitAsteria("Menu", "loadHTML_forMenu", {}, "", "/menu/");
          break;
        // ログイン失敗
        // Login failed
        case 1:
          this.password = "";
          this.login_message = response.responseData.errorMessage;
          break;
        // ログイン変更の可能性
        // Maybe login password was changed
        case 2:
          this.password = "";
          this.$bootstrap.showModal("new_password");
          // this.login_message = "パスワードが変更されている可能性がございます";
          break;
      }
      this.isProcessing = false;
    },
    async loginAfterChangePasswordHandler(newPassWord) {
      this.password = newPassWord;
      await this.loginHandler();
    },

    openForgetModalHandler() {
      this.finishedReset = false;
      this.reset_user_id = "";
      this.reset_message_status = "";
      this.reset_message_body = "";
    },

    async resetPasswordHandler() {
      this.reset_message_body = "";
      this.finishedReset = true;

      const response = await this.postAsteria("Login", "resetPassword", {
        user_id: this.reset_user_id
      });

      switch (response.responseData.return) {
        case 0:
          this.reset_message_status = "success";
          this.reset_message_body = response.responseData.message;
          this.finishedReset = true;
          break;
        case 1:
          this.reset_message_status = "danger";
          this.reset_message_body = response.responseData.errorMessage;
          this.finishedReset = false;
          break;
      }
    }
  }
};
</script>

<style lang="scss"></style>
